import React from 'react';
import DeleteHoldButton from '../common/DeleteHoldButton';

export type ProgramPresentationListRowActionsProps = {
  annualCellKey: string;
  canCopy: boolean;
  canDelete: boolean;
  disabled?: boolean;
  /** UI 라벨(기본: 프레젠테이션) */
  resourceLabel?: string;
  onCopy: (annualCellKey: string) => void;
  onDelete: (annualCellKey: string) => void;
};

const ProgramPresentationListRowActions: React.FC<ProgramPresentationListRowActionsProps> = ({
  annualCellKey,
  canCopy,
  canDelete,
  disabled = false,
  resourceLabel = '프레젠테이션',
  onCopy,
  onDelete,
}) => {
  const trashDisabled = disabled || !canDelete;

  return (
    <div
      className="cp-program-learning-slide-modal-actions cp-program-presentation-list-row-actions"
      role="group"
      aria-label={`${resourceLabel} 복사 및 삭제`}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="cp-program-learning-slide-action-btn"
        disabled={disabled || !canCopy}
        title={canCopy ? `${resourceLabel} 복사` : `복사할 ${resourceLabel}이 없습니다`}
        aria-label={`${resourceLabel} 복사`}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onCopy(annualCellKey);
        }}
      >
        <img
          src="/Copy.svg"
          alt=""
          width={15}
          height={15}
          aria-hidden
          className="cp-program-learning-slide-action-icon"
        />
      </button>
      <DeleteHoldButton
        className="cp-program-learning-slide-action-btn cp-program-learning-slide-trash-btn"
        holdBarClassName="cp-program-learning-slide-trash-hold-bar"
        holdMs={1000}
        disabled={trashDisabled}
        disabledTitle={`삭제할 ${resourceLabel}이 없습니다`}
        disabledAriaLabel={`삭제할 ${resourceLabel}이 없습니다`}
        title={`${resourceLabel} 삭제 (짧게: 확인 후 삭제 · 길게: 바로 삭제)`}
        ariaLabel={`${resourceLabel} 삭제`}
        confirmTitle={`${resourceLabel} 삭제할까요?`}
        confirmDescription="삭제하면 되돌릴 수 없습니다."
        onDelete={() => onDelete(annualCellKey)}
      >
        <img
          src="/Trash.svg"
          alt=""
          width={15}
          height={15}
          aria-hidden
          className="cp-program-learning-slide-trash-icon"
        />
      </DeleteHoldButton>
    </div>
  );
};

export default ProgramPresentationListRowActions;
